export const CHOICE_DISPLAY_LENGTH = 40;
export const MESSAGES_CONTAINER_ID = 'eds__chat-messages-container';
export const MESSAGE_ACTIONS_CLASSNAME = 'eds__chat-message-actions';
